// Medição — GA4 e/ou GTM carregados somente após o consentimento de cookies (Consent Mode v2).
// IDs via variáveis de ambiente: REACT_APP_GA4_ID (G-XXXXXXXXXX) e REACT_APP_GTM_ID (GTM-XXXXXXX).
// Enquanto estiverem vazios, nenhum script de medição é carregado; os eventos ficam apenas no dataLayer local.

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const GTM_ID = process.env.REACT_APP_GTM_ID || "";
const isGa4 = (id) => /^G-[A-Z0-9]+$/.test(id);
const isGtm = (id) => /^GTM-[A-Z0-9]+$/.test(id);

let initialized = false;

export const consentGranted = () => {
  try {
    return !!localStorage.getItem("melo-lgpd-ok");
  } catch (e) {
    return false;
  }
};

// Carrega gtag.js e/ou GTM — chamar apenas depois do aceite do banner de cookies.
export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;
  try {
    if (isGa4(GA4_ID)) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
      document.head.appendChild(s);
      window.gtag("js", new Date());
      window.gtag("config", GA4_ID, { anonymize_ip: true });
    }
    if (isGtm(GTM_ID)) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", GTM_ID);
    }
  } catch (e) {
    /* medição nunca deve quebrar a página */
  }
};

// Consent Mode v2: concede o uso de cookies de medição e inicia o carregamento.
// O default "denied" está inline no index.html.
export const grantAnalytics = () => {
  try {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
    });
  } catch (e) {
    /* medição nunca deve quebrar a página */
  }
  initAnalytics();
};

export const track = (event, data = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
    if (typeof window.gtag === "function") window.gtag("event", event, data);
  } catch (e) {
    /* medição nunca deve quebrar a página */
  }
};

const origemServico = (path = "") => path.split("/").filter(Boolean)[0] || "home";

export const trackWhatsApp = (origem = "home") => track("click_whatsapp", { origem, servico: origemServico(origem) });
export const trackTelefone = (origem = "home") => track("click_phone", { origem });
export const trackEmail = (origem = "home") => track("click_email", { origem });
export const trackLinkedIn = (origem = "home") => track("click_linkedin", { origem });
export const trackContactForm = (origem = "home") => track("form_submit_contato", { origem });
export const trackChecklistForm = () => track("form_submit_checklist", { origem: "home" });
export const trackDownload = (material) => track("download_material", { material });
